<template>
  <div class="material-card-list mr-6 mb-6">
    <div
      class="main-check flex items-center mb-2"
      v-if="!mainSet"
    >
      <button
        class="rounded flex justify-center items-center focus:outline-none"
        @click="
          $store.dispatch('materials/toggleMain', material.data.material_id)
        "
      >
        <span class="check"><i
            v-if="material.data.attributes.main"
            class="fas fa-check text-red-500"
          ></i></span>
        <span class="ml-2 text-sm">{{$t('admin.materials.list_card.main')}}</span>
      </button>
    </div>
    <div class="image relative mb-2">
      <button
        @click="toggleStatus"
        class="absolute top-2 left-2 bg-white rounded w-6 h-6 flex justify-center items-center"
      >
        <i
          v-if="!material.data.attributes.status"
          class="fa fa-lock text-red-500"
          :title="$t('main.not_active')"
        ></i>
        <i
          v-else
          class="fa fa-check text-green-500"
          :title="$t('main.active')"
        ></i>
      </button>
      <button
        @click="remove"
        :title="$t('main.button_delete')"
        class="absolute top-2 right-2 bg-white rounded w-6 h-6 flex justify-center items-center"
      >
        <i class="fas fa-times fa-lg text-red-500"></i>
      </button>
      <router-link
        class="block rounded border-2 border-white"
        :to="{
          name: 'edit_material',
          params: { material_id: material.data.material_id },
        }"
        :style="{ backgroundImage: `url(${material.data.attributes.image})` }"
      ></router-link>
    </div>
    <div class="article font-bold text-sm">
      {{ material.data.attributes.article }}
    </div>
    <div class="name text-xs">
      {{ $knifeString(material.data.attributes.name, 15) }}
    </div>
    <div class="coefficient text-sm">
      Кф. цен:
      <span class="font-bold underline">{{
        material.data.attributes.cost_coefficient
      }}</span>
    </div>
    <div class="price-cub text-xs">
      <div v-html="$t('admin.materials.list_card_in_element.price_cub')"></div>
      <div>{{ $toCurrency(material.data.attributes.price) }}</div>
    </div>
    <div class="cost-value text-xs">
      <div v-html="$t('admin.materials.list_card_in_element.cost_cub')"></div>
      <div>{{ $toCurrency(material.data.attributes.cost) }}</div>
    </div>
    <div
      class="type text-xs"
      v-if="!mainSet && material.data.attributes.type"
    >
      {{ $knifeString(material.data.attributes.type.name, 15) }}
    </div>
  </div>
</template>

<script>
export default {
  name: "MaterialListCard",
  props: {
    material: {
      type: Object,
      required: true,
    },
    mainSet: {
      type: Boolean,
    },
    inForm: {
      type: Boolean,
    },
  },
  methods: {
    toggleStatus() {
      this.$store.dispatch(
        "materials/toggleStatus",
        this.material.data.material_id
      );
    },
    remove() {
      if (!this.inForm) {
        if (this.mainSet) {
          this.$store.dispatch(
            "materials/toggleMain",
            this.material.data.material_id
          );
        } else {
          this.$store.dispatch(
            "materials/remove",
            this.material.data.material_id
          );
        }
      }
    },
  },
};
</script>
<style scoped>
.material-card-list {
  display: flex;
  flex-direction: column;
  row-gap: 3px;
}
</style>

